import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ModalConfirmDeleteData {
  modalTitle: string;
  text: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
}

@Component({
  selector: 'app-modal-confirm-delete',
  templateUrl: './modal-confirm-delete.component.html',
  styleUrls: ['./modal-confirm-delete.component.scss'],
  standalone: false,
})
export class ModalConfirmDeleteComponent {
  protected data = inject<ModalConfirmDeleteData>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<ModalConfirmDeleteComponent>>(MatDialogRef);

  public cancelButtonClicked(): void {
    this.dialogRef.close(false);
  }

  public confirmButtonClicked(): void {
    this.dialogRef.close(true);
  }

  public closeDetail(): void {
    this.dialogRef.close(false);
  }
}
